<template lang="html">
  <section class="c-about" :class="displayedClass">
    <div class="c-about__content">
        <p>
          Hey ! I’m Théo Kleman, a 20 years old web developer based in Paris.
          <br>
          Currently in fourth year <a target="_blank" href="http://www.hetic.net/">@hetic</a>, I also work as a freelancer !
        </p>

        <p class="last">
          I’ve worked for a few clients, for which I used lovely stacks composed of ReactJS, VueJS, AngularJS, Sass, Webpack & Gulp.
          <br>
          I'm also familiar with ES6. I'm currently learning WebGL stuff. You can also download <a target="_blank" href="./static/cv-theokleman.pdf">my resume</a> !
        </p>

        <span>
          If you have something you want to discuss, feel free to contact me :)
        </span>

        <div class="c-about__content__socials">
          <div>
            <a target="_blank" href="https://twitter.com/Theo_KlMan">twitter</a>
          </div>
          <div>
            <a target="_blank" href="https://fr.linkedin.com/in/theokleman">linkedin</a>
          </div>
          <div>
            <a target="_blank" href="https://github.com/TheoKleman/">github</a>
          </div>
          <div>
            <a target="_blank" href="http://codepen.io/theElkman/">codepen</a>
          </div>
          <div>
            <a href="mailto:theokleman.com">mail</a>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

import { TweenLite, TimelineLite, Power2 } from 'gsap'

export default {
  computed: {
    ...mapGetters([
      'touchDevice',
      'clientDimensions',
      'aboutDisplay'
    ]),
    displayedClass () {
      return {
        's--displayed': this.aboutDisplay
      }
    }
  },
  watch: {
    aboutDisplay () {
      if (this.aboutDisplay === true) {
        this.show()
      } else {
        this.hide()
      }
    }
  },
  methods: {
    onKeyUp (e) {
      if (!this.switchingSlides && !this.toggleHover) {
        if (e.keyCode === 27) {
          if (this.aboutDisplay === true) {
            this.$store.dispatch('setAboutDisplay', false)
          }
        }
      }
    },
    show () {
      this.setContentTweens()

      if (this.clientDimensions.width < 501) {
        let tlMobile = new TimelineLite()

        tlMobile.add(
          TweenLite.to(this.$el, 0.35, {
            scale: 1,
            opacity: 1,
            ease: Power2.easeInOut
          }), 'start'
        )

        tlMobile.add(
          TweenLite.to(this.$p[0], 0.8, {
            opacity: 1,
            ease: Power2.easeOut
          }), 'start+=.3'
        )

        tlMobile.add(
          TweenLite.to(this.$p[1], 0.8, {
            opacity: 1,
            ease: Power2.easeOut
          }), 'start+=.5'
        )

        tlMobile.add(
          TweenLite.to(this.$span, 0.8, {
            opacity: 1,
            ease: Power2.easeOut
          }), 'start+=.7'
        )

        tlMobile.add(
          TweenLite.to(this.$socials, 0.55, {
            opacity: 1,
            ease: Power2.easeOut
          }), 'start+=.9'
        )
      } else {
        let tlDefault = new TimelineLite()

        tlDefault.add(
          TweenLite.to(this.$el, 0.35, {
            scale: 1,
            opacity: 1,
            ease: Power2.easeInOut
          }), 'start'
        )

        tlDefault.add(
          TweenLite.to(this.$p[0], 0.8, {
            width: '100%',
            x: 0,
            ease: Power2.easeOut
          }), 'start+=.3'
        )

        tlDefault.add(
          TweenLite.to(this.$p[1], 0.8, {
            width: '100%',
            x: 0,
            ease: Power2.easeOut
          }), 'start+=.5'
        )

        tlDefault.add(
          TweenLite.to(this.$span, 0.8, {
            width: '100%',
            x: 0,
            ease: Power2.easeOut
          }), 'start+=.7'
        )

        tlDefault.add(
          TweenLite.to(this.$socials, 0.55, {
            opacity: 1,
            ease: Power2.easeOut
          }), 'start+=.9'
        )
      }
    },
    hide () {
      TweenLite.to(this.$el, 0.45, {
        scale: 1.15,
        opacity: 0,
        ease: Power2.easeInOut,
        onComplete: this.setContentTweens()
      })
    },
    setContentTweens () {
      if (this.clientDimensions.width < 501) {
        TweenLite.set([this.$p, this.$span], {
          opacity: 0
        })
      } else {
        TweenLite.set([this.$p, this.$span], {
          width: '0%',
          x: -2
        })
      }
      TweenLite.set(this.$socials, {
        opacity: 0
      })
    }
  },
  mounted () {
    this.$p = this.$el.getElementsByTagName('p')
    this.$span = this.$el.getElementsByTagName('span')
    this.$socials = this.$el.querySelector('.c-about__content__socials')

    this.setContentTweens()

    TweenLite.set(this.$el, {
      scale: 1.15,
      opacity: 0
    })
  },
  created () {
    window.addEventListener('keyup', (e) => this.onKeyUp(e))
  }
}
</script>

<style lang="scss">
@import "../../vars.scss";

.c-about {
  position: absolute;
  z-index: 55;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $dark url('../../../static/img/pp.png') no-repeat bottom right;
  background-size: 50%;
  padding: 12% 13%;
  opacity: 0;
  pointer-events: none;

  &.s--displayed {
    pointer-events: all;
  }

  &__content {
    color: $white-op;

    p, span {
      display: block;
      overflow: hidden;
      word-break: break-all;
      white-space: nowrap;
      width: 100%;
    }

    > p {
      font-family: $proxima;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      margin-bottom: 40px;

      &.last {
        margin-bottom: 60px;
      }
    }

    > span {
      color: rgba($white, .25);
      font-style: italic;
    }

    a {
      color: $orange;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    &__socials {
      display: flex;
      margin-top: 60px;

      > div {
        margin-right: 25px;
        font-size: 20px;

        > a {
          &:hover {
            text-decoration: none;
            color: $white;
          }
        }
      }
    }
  }

  @media screen and (max-width: $tablet) {
    padding-left: 5%;
    padding-right: 5%;
    background-size: 100%;
  }

  @media screen and (max-width: $mobile) {
    padding-top: 90px;

    p, span {
      display: block;
      word-break: normal;
      white-space: normal;
      width: 100%;
    }

    p {
      font-size: 14px;
      line-height: 26px;

      &.last {
        margin-bottom: 45px;
      }
    }

    span {
      font-size: 15px;
    }

    .c-about__content__socials {
      margin-top: 45px;
    }

    .c-about__content__socials > div {
      margin-right: 15px;

       > a {
         font-size: 17px;
       }
    }
  }
}
</style>



// WEBPACK FOOTER //
// About.vue?82ea4d18